import { cn, ClassValue } from "@/libs/utils/tailwind/cn";
import { SlotsToClasses } from "@nextui-org/react";

export default function ArrowBackIcon({
  className,
  classNames,
  strokeWidth,
}: Props) {
  return (
    <svg
      className={cn(className, classNames?.base)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      stroke="currentColor"
    >
      <path
        d="M15.832 10H4.16536"
        strokeWidth={strokeWidth ?? 1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={cn(classNames?.path)}
      />
      <path
        d="M10 4.16699L4.16667 10.0003L10 15.8337"
        strokeWidth={strokeWidth ?? 1.66667}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={cn(classNames?.path)}
      />
    </svg>
  );
}

interface Props extends Pick<React.SVGProps<SVGSVGElement>, "strokeWidth"> {
  className?: ClassValue;
  classNames?: SlotsToClasses<"base" | "path">;
}
